<template>
  <v-app-bar v-if="showMe"
             :app="fullscreen"
             :class="!fullscreen ? 'restion-store__footer' : null"
             :dark="dark"
             :color="color"
             :elevation="elevation"
             bottom
             class="py-0 px-0"
             fixed
  >
    <v-container class="my-0 py-0 px-0 d-flex flex-row pr-4">
      <NavigationButton key="nav" :dark="dark" position="bottom-left" />
      <v-spacer />
      <v-fade-transition group mode="out-in" hide-on-leave class="d-flex flex-grow-1">
        <Button v-if="!readonly && !hasPoint"
                key="1"
                :to="{name: 'address'}"
                title="position-need-location-2"
                subtitle="position-need-location-1"
                :dark-override="true"
                color-override="red darken-4"
                reversed
                class="flex-fill"
                inline
                @click.native="$ym.do('footer_need_location')"
        />
        <Button v-else-if="!readonly && lowOrder"
                key="2"
                :dark-override="true"
                color-override="red darken-4"
                class="flex-fill"
                inline
                @click.native="$ym.do('footer_low_money')"
        >
          <template v-slot:default>
            {{ $dictionary.get('min-order-price-is-2') }} {{ $tools.money(price) }}
          </template>
          <template v-slot:subtitle>
            {{ $dictionary.get('min-order-price-is') }} {{ $tools.money(priceMin) }}
          </template>
        </Button>
        <Button v-else-if="!readonly && quantity === 0"
                key="3"
                class="flex-fill"
                inline
                disabled
                transparent
                :dark-override="dark"
        >
          <template v-slot:default>
            {{ $dictionary.get('basket-is-empty') }}
          </template>
        </Button>
        <Button v-else-if="!readonly && quantity > 0"
                key="99"
                class="flex-fill"
                inline
                title="go-to-checkout-1"
                to="/checkout"
                @click.native="$ym.do('footer_checkout')"
        >
          <template v-slot:subtitle>
            <div class="d-flex flex-row">
              <Counter :value="quantity" class="mr-1" />
              {{ $dictionary.get('go-to-checkout-2') }}
              <Counter :value="priceFormatted" class="ml-1 mr-1" />
              {{ $store.state.data.settings.currency_sign || '₽' }}
            </div>
          </template>
        </Button>
      </v-fade-transition>
      <v-spacer />
    </v-container>
  </v-app-bar>
</template>

<script>
import Button from '@/components/Button';
import NavigationButton from '@/components/NavigationButton';
import Counter from './Counter';

export default {
  name: 'Footer',
  components: { NavigationButton, Button, Counter },
  props: {},
  created() {
    const { theme } = this.$store.state;
    this.dark = theme.footerDark;
    this.elevation = this.$store.state.theme.footerElevation;
    this.color = this.$store.state.theme.footerColor;
    this.fullscreen = this.$store.state.ui.fullscreen;
  },
  computed: {
    buttonColor() {
      if (this.colorOverride !== null) return this.colorOverride;
      if (this.subButton && !this.text) return null;
      if (this.grey) return 'grey';
      return this.$store.state.theme.buttonColor;
    },
    point() {
      return this.$store.state.data.point;
    },
    pointData() {
      if (!this.point) return {};
      return this.$store.state.data.points[this.point];
    },
    canOrder() {
      return this.pointData && this.pointData.order_time_ok;
    },
    basket() {
      return this.$store.state.basket.items;
    },
    quantity() {
      return this.$store.getters['basket/totals'].quantity;
    },
    price() {
      return this.$store.getters['basket/totals'].price;
    },
    priceFormatted() {
      return this.$tools.string.numberFormat(this.price);
    },
    hasPoint() {
      if (this.$store.state.data.mode === 'pickup') return true;
      return this.$store.state.data.point !== null;
    },
    priceMin() {
      if (this.$store.state.data.mode === 'pickup') return 0;
      if (this.hasPoint) {
        return this.pointData.order_sum_threshold;
      }
      return 0;
    },
    lowOrder() {
      return this.price > 0 && this.priceMin > this.price;
    },
    readonly() {
      return this.$store.state.data.settings.readonly;
    },
    showMe() {
      if (this.readonly) return false;
      switch (this.$route.name) {
        case 'checkout':
          return this.lowOrder;
        case 'showcase':
          return true;
        default:
          return false;
      }
    },
  },
};
</script>
